/* Modulo: Features Orbit: scroll reveal + centre video.
   Loaded only when the reveal is on or a video is set. Vanilla, no deps.
   `moduloLazyInit` is deliberately not used: it does not exist. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced() { return !!(mq && mq.matches); }

  // ─── Reveal ───
  // Armed only when the section starts BELOW the viewport: arming one that is
  // already on screen would hide content the shopper can see, then replay it.
  // With no IntersectionObserver, reduced motion or the theme editor, nothing
  // is ever hidden.
  function initReveal(root) {
    if (root.getAttribute('data-fob-reveal') !== 'true') return;
    if (reduced() || !('IntersectionObserver' in window)) return;
    if (window.Shopify && window.Shopify.designMode) return;
    var stage = root.querySelector('[data-fob-stage]') || root;
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    if (stage.getBoundingClientRect().top < vh * 0.92) return;

    root.classList.add('is-armed');
    function show() {
      root.classList.add('is-in');
      if (io) io.disconnect();
    }
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { show(); return; }
      }
    }, { threshold: 0.2 });
    io.observe(stage);
    // A shopper who switches motion off mid-session gets the finished state.
    if (mq && mq.addEventListener) mq.addEventListener('change', function () { if (reduced()) show(); });
  }

  // ─── Video ───
  // The markup carries no `autoplay`: this script starts it, so with no JS
  // there is no motion and the (hidden) control never appears. Paused under
  // reduced motion, and while scrolled out of view.
  function initVideo(root) {
    var v = root.querySelector('[data-fob-video]');
    var btn = root.querySelector('[data-fob-toggle]');
    if (!v || !btn) return;
    var byUser = false;

    function sync() {
      var paused = v.paused;
      btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      if (paused) btn.classList.add('is-paused'); else btn.classList.remove('is-paused');
    }
    function play() {
      var p = v.play();
      if (p && p.catch) p.catch(function () { sync(); });
    }

    v.muted = true;
    btn.hidden = false;
    btn.addEventListener('click', function () {
      if (v.paused) { byUser = false; play(); } else { byUser = true; v.pause(); }
    });
    v.addEventListener('play', sync);
    v.addEventListener('pause', sync);

    if (!reduced()) {
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[entries.length - 1];
          if (e.isIntersecting) { if (!byUser && v.paused) play(); }
          else if (!v.paused) v.pause();
        }, { threshold: 0.25 }).observe(v);
      } else {
        play();
      }
    }
    sync();
  }

  function init(root) {
    if (!root || root.__moduloFob) return;
    root.__moduloFob = true;
    initReveal(root);
    initVideo(root);
  }

  function boot() {
    var els = document.querySelectorAll('[data-modulo-fob]');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }

  if (!window.__moduloFobWired) {
    window.__moduloFobWired = true;
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target && e.target.querySelector ? e.target.querySelector('[data-modulo-fob]') : null;
      init(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
